import { useState } from 'react';
import { spore } from '@/spore/runtime';
import { Panel } from './Panel';
import { CalibrationOverlay } from './CalibrationOverlay';
import { Slider } from '@/components/ui/slider';

const SHOWN = [
  ['ccBaseline', 'CC baseline'],
  ['ccNoiseFloor', 'CC noise floor ±'],
  ['ccMax', 'CC max'],
  ['noiseVelocity', 'Note noise gate'],
  ['pulseVelocity', 'Pulse velocity ≥'],
  ['pulseCcJump', 'Pulse CC jump ≥'],
  ['refractoryMs', 'Refractory ms'],
  ['strokeMinDurationMs', 'Stroke min ms'],
  ['strokeMinEvents', 'Stroke min events'],
  ['gentleVelMax', 'Gentle vel p95'],
  ['gentleCcJumpMax', 'Gentle CC jump max'],
];

const StrictnessControl = ({ value }) => (
  <div data-testid="strictness-control" className="mt-5 border-t border-[var(--hair)] pt-4">
    <div className="mb-2 flex items-baseline justify-between">
      <span className="label-eyebrow">Pulse strictness ( [ / ] on stage )</span>
      <span data-testid="strictness-value" className="font-display text-2xl font-bold glow-amber">{value}/5</span>
    </div>
    <Slider data-testid="strictness-slider" min={1} max={5} step={1} value={[value]} onValueChange={(v) => spore.setStrictness(v[0])} />
    <div className="mt-1 flex justify-between text-[0.65rem] text-[var(--dim)]"><span>LOOSE</span><span>DEFAULT 3</span><span>STRICT</span></div>
  </div>
);

export const CalibrationPanel = ({ snap }) => {
  const [open, setOpen] = useState(false);
  const th = snap.thresholds;
  return (
    <Panel
      testId="calibration-panel"
      code="06 / CALIBRATION"
      title="Thresholds"
      delay={320}
      right={
        <span data-testid="calibration-state" className={`text-xs tracking-[0.2em] ${snap.calibrated ? 'glow-spore' : 'text-[var(--amber)]'}`}>
          {snap.calibrated ? 'CALIBRATED' : 'DEFAULTS'}
        </span>
      }
    >
      <dl data-testid="thresholds-display" className="grid grid-cols-2 gap-x-6 gap-y-1.5 text-sm">
        {SHOWN.map(([k, label]) => (
          <div key={k} className="flex justify-between border-b border-white/5 py-1">
            <dt className="text-[var(--muted)]">{label}</dt>
            <dd data-testid={`threshold-${k}`} className="tabular-nums text-[var(--ink)]">{th[k] > 127 && k.startsWith('pulse') ? 'off' : th[k]}</dd>
          </div>
        ))}
        <div className="flex justify-between border-b border-white/5 py-1">
          <dt className="text-[var(--muted)]">Still at</dt>
          <dd className="tabular-nums">{th.stillThresholdsS.join(' / ')}s</dd>
        </div>
      </dl>
      {snap.calibratedAt && <div data-testid="calibration-timestamp" className="mt-3 text-xs text-[var(--dim)]">Saved {new Date(snap.calibratedAt).toLocaleString()}</div>}
      <div className="mt-5 grid grid-cols-2 gap-3">
        <button data-testid="calibration-launch-button" className="btn-lab primary" onClick={() => setOpen(true)}>Calibrate touch (~28s)</button>
        <button data-testid="calibration-reset-button" className="btn-lab danger" disabled={!snap.calibrated} onClick={() => spore.resetCalibration()}>Reset to defaults</button>
      </div>
      {open && <CalibrationOverlay onClose={() => setOpen(false)} />}

    </Panel>
  );
};
